import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Duplicate = createSvgIcon(
  <path d="M6 0v4.5H1.5V24H18v-4.5h4.5V5.108L16.541 0H6Zm8.25 2.25V7.5h6v9.75h-12v-15h6Zm4.959 3H16.5V2.928l2.709 2.322ZM3.75 6.75H6V19.5h9.75v2.25h-12v-15Z" />,
  'Duplicate'
);

export { Duplicate };